import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { TOOLS, toolStore } from "@/stores/tools.svelte";

var $$_import_toolStore = $.reactive_import(() => toolStore);
var root_1 = $.from_html(`<button><span class="tool-name svelte-1p38h3yywau0p"> </span> <kbd class="key-hint svelte-1p38h3yywau0p"> </kbd></button>`);
var root_2 = $.from_html(`<div class="size-row svelte-1p38h3yywau0p"><label for="eraser-size" class="size-label svelte-1p38h3yywau0p">Size</label> <input id="eraser-size" type="range" min="1" max="10" class="size-slider svelte-1p38h3yywau0p"/> <span class="size-val svelte-1p38h3yywau0p"> </span></div>`);
var root_3 = $.from_html(`<div class="size-row svelte-1p38h3yywau0p"><label for="brush-size" class="size-label svelte-1p38h3yywau0p">Size</label> <input id="brush-size" type="range" min="1" max="10" class="size-slider svelte-1p38h3yywau0p"/> <span class="size-val svelte-1p38h3yywau0p"> </span></div>`);
var root = $.from_html(`<div class="tool-picker svelte-1p38h3yywau0p"><label class="section-label svelte-1p38h3yywau0p">Tool</label> <div class="tool-buttons svelte-1p38h3yywau0p"></div> <!> <p class="hint svelte-1p38h3yywau0p"> </p></div>`);

function ToolPicker($$anchor, $$props) {
	$.push($$props, false);
	$.init();

	var div = root();
	var div_1 = $.sibling($.child(div), 2);

	$.each(div_1, 5, () => TOOLS, $.index, ($$anchor, tool) => {
		var button = root_1();
		let classes;
		var span = $.child(button);
		var text = $.child(span, true);

		$.reset(span);

		var kbd = $.sibling(span, 2);
		var text_1 = $.child(kbd, true);

		$.reset(kbd);
		$.reset(button);

		$.template_effect(() => {
			classes = $.set_class(button, 1, 'tool-btn svelte-1p38h3yywau0p', null, classes, { active: $$_import_toolStore().activeTool === $.get(tool).id });
			$.set_attribute(button, 'title', $.get(tool).label);
			$.set_text(text, $.get(tool).label);
			$.set_text(text_1, $.get(tool).key);
		});

		$.delegated('click', button, () => $$_import_toolStore().setTool($.get(tool).id));
		$.append($$anchor, button);
	});

	$.reset(div_1);

	var node = $.sibling(div_1, 2);

	{
		var consequent = ($$anchor) => {
			var div_2 = root_2();
			var input = $.sibling($.child(div_2), 2);

			$.remove_input_defaults(input);

			var span_1 = $.sibling(input, 2);
			var text_2 = $.child(span_1, true);

			$.reset(span_1);
			$.reset(div_2);
			$.template_effect(() => $.set_text(text_2, $$_import_toolStore().eraserSize));
			$.bind_value(input, () => $$_import_toolStore().eraserSize, ($$value) => $$_import_toolStore($$_import_toolStore().eraserSize = $$value));
			$.append($$anchor, div_2);
		};

		var consequent_1 = ($$anchor) => {
			var div_3 = root_3();
			var input_1 = $.sibling($.child(div_3), 2);

			$.remove_input_defaults(input_1);

			var span_2 = $.sibling(input_1, 2);
			var text_3 = $.child(span_2, true);

			$.reset(span_2);
			$.reset(div_3);
			$.template_effect(() => $.set_text(text_3, $$_import_toolStore().brushSize));
			$.bind_value(input_1, () => $$_import_toolStore().brushSize, ($$value) => $$_import_toolStore($$_import_toolStore().brushSize = $$value));
			$.append($$anchor, div_3);
		};

		$.if(node, ($$render) => {
			if ($$_import_toolStore().activeTool === "eraser") $$render(consequent); else if ($$_import_toolStore().activeTool === "freehand" || $$_import_toolStore().activeTool === "line" || $$_import_toolStore().activeTool === "rect") $$render(consequent_1, 1);
		});
	}

	var p = $.sibling(node, 2);
	var text_4 = $.child(p, true);

	$.reset(p);
	$.reset(div);
	$.template_effect(() => $.set_text(text_4, $$_import_toolStore().hint));
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	ToolPicker = $.hmr(ToolPicker);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1p38h3yywau0p');
		ToolPicker[$.HMR].update(module.default);
	});
}

export default ToolPicker;

$.delegate(['click']);
import "bun-svelte:ToolPicker.svelte-d2cnbl2fwvtt-style.css";